<div class="dialog">
  <div class="title-container">
    <div class="title-left">
      <mat-icon class="icon-title">filter_alt</mat-icon>
      <h3 class="title">{{ "FilterUsageGuideTitle" | translate }}</h3>
    </div>
    <div class="header-actions">
      <button
        class="header-icon-btn download-btn"
        type="button"
        mat-icon-button
        (click)="downloadPdf()"
        [matTooltip]="'FilterUsageGuideDownloadPdf' | translate"
        matTooltipPosition="below"
      >
        <mat-icon>download</mat-icon>
      </button>
      <button
        class="header-icon-btn close-btn"
        (click)="onClose()"
        mat-icon-button
        [matTooltip]="'Close' | translate"
        matTooltipPosition="below"
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <p class="subtitle">{{ "FilterUsageGuideSubtitle" | translate }}</p>

  <mat-tab-group
    class="filter-tabs"
    [(selectedIndex)]="selectedTabIndex"
    animationDuration="150ms"
    mat-stretch-tabs="false"
  >
    <!-- Tab 1: How to use the filters (step-by-step + buttons) -->
    <mat-tab>
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">help_outline</mat-icon>
        <span>{{ "FilterGuideHowToTabLabel" | translate }}</span>
      </ng-template>

      <div class="tab-body">
        <!-- Step-by-step guide: how to add a filter -->
        <div class="how-to-section">
          <h4 class="how-to-title">
            <mat-icon>help_outline</mat-icon>
            {{ "FilterGuideHowToTitle" | translate }}
          </h4>
          <ol class="how-to-steps">
            <li>{{ "FilterGuideStep1" | translate }}</li>
            <li>{{ "FilterGuideStep2" | translate }}</li>
            <li>{{ "FilterGuideStep3" | translate }}</li>
            <li>{{ "FilterGuideStep4" | translate }}</li>
            <li>{{ "FilterGuideStep5" | translate }}</li>
          </ol>
        </div>

        <!-- Button reference section -->
        <div class="buttons-section">
          <h4 class="buttons-title">{{ "FilterGuideButtonsTitle" | translate }}</h4>
          <div class="button-list">
            <div class="button-item">
              <div class="button-pill apply">{{ "FilterGuideButtonApply" | translate }}</div>
              <span class="button-desc">{{ "FilterGuideButtonApplyDesc" | translate }}</span>
            </div>
            <div class="button-item">
              <div class="button-pill sort">
                <mat-icon>arrow_upward</mat-icon>{{ "FilterGuideButtonSortAsc" | translate }}
              </div>
              <span class="button-desc">{{ "FilterGuideButtonSortAscDesc" | translate }}</span>
            </div>
            <div class="button-item">
              <div class="button-pill sort">
                <mat-icon>arrow_downward</mat-icon>{{ "FilterGuideButtonSortDesc" | translate }}
              </div>
              <span class="button-desc">{{ "FilterGuideButtonSortDescDesc" | translate }}</span>
            </div>
            <div class="button-item">
              <div class="button-pill remove">
                <mat-icon>close</mat-icon>{{ "FilterGuideButtonRemove" | translate }}
              </div>
              <span class="button-desc">{{ "FilterGuideButtonRemoveDesc" | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>

    <!-- Tab 2+: Filter type tabs (currently only TEXT — others commented in component) -->
    <mat-tab *ngFor="let tab of filterTabs">
      <ng-template mat-tab-label>
        <mat-icon class="tab-icon">{{ tab.icon }}</mat-icon>
        <span>{{ tab.titleKey | translate }}</span>
      </ng-template>

      <div class="tab-body">
        <p class="tab-description">{{ tab.descriptionKey | translate }}</p>

        <div class="when-to-use">
          <mat-icon>lightbulb_outline</mat-icon>
          <div>
            <span class="when-label">{{ "FilterGuideWhenToUseLabel" | translate }}:</span>
            <span>{{ tab.whenToUseKey | translate }}</span>
          </div>
        </div>

        <h4 class="operators-title">
          {{ "FilterGuideOperatorsAvailable" | translate }}
        </h4>

        <div class="operators-list">
          <div class="operator-card" *ngFor="let op of tab.operators">
            <div class="operator-symbol">{{ op.symbol }}</div>
            <div class="operator-content">
              <div class="operator-name">{{ op.nameKey | translate }}</div>
              <p class="operator-desc">{{ op.descriptionKey | translate }}</p>
              <div class="operator-example">
                <span class="example-label">{{ "FilterGuideExampleLabel" | translate }}:</span>
                <span class="example-text">{{ op.exampleKey | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
